import { useEffect, useState } from "react";

import { useGlobalContext } from "../../GlobalContext";

import { Toaster, toast } from "sonner";

import useShop from "../../Sevices/useShop";
import useDriverTeams from "../../Sevices/Driver Api/useDriverTeams";
import useTeams from "../../Sevices/useTeams";

import TeamDropdown from "../Utils/TeamDropdown";

import DeliveryChargeModal from "./compoents/DeliveryChargeModal";

import ShopTabs from "./ShopTabs";

export default function ShopsPage() {
  // =====================================================
  // GLOBAL
  // =====================================================

  const { AdminId } = useGlobalContext();

  // =====================================================
  // SHOP API
  // =====================================================

  const {
    shops,
    loading,

    fetchShops,

    addShop,

    fetchLatLong,

    updateShopLatLong,

    updateShopStatus,
    statusUpdatingId,

    // DELIVERY CHARGES

    deliveryCharges,
    deliveryChargesLoading,

    deliveryChargeSaving,

    deliveryChargeDeletingId,

    fetchDeliveryCharges,

    saveDeliveryCharge,

    deleteDeliveryCharge,
  } = useShop();

  // =====================================================
  // TEAM API
  // =====================================================

  const { teams, fetchDriverTeams } = useDriverTeams();

  const { assignShopToTeam } = useTeams();

  // =====================================================
  // TAB
  // =====================================================

  const [activeTab, setActiveTab] = useState("list");

  // =====================================================
  // COMMON MODAL
  // =====================================================

  const [modalType, setModalType] = useState("");

  const [selectedShopId, setSelectedShopId] = useState(null);

  const [selectedTeam, setSelectedTeam] = useState("");

  // =====================================================
  // ONBOARD FORM
  // =====================================================

  const [formData, setFormData] = useState({
    shopCode: "",
    shopAddress: "",
    shopName: "",
    shopPhone: "",
    shopPinCode: "",
    shopPanCard: "",
    shopGst: "",
    latitude: "",
    longitude: "",
  });

  // =====================================================
  // EDIT FORM
  // =====================================================

  const [editFormData, setEditFormData] = useState({
    shopCode: "",
    shopAddress: "",
    shopName: "",
    shopPhone: "",
    shopPinCode: "",
    shopPanCard: "",
    shopGst: "",
    shopLatitude: "",
    shopLongitude: "",
    adminId: AdminId,
  });

  // =====================================================
  // DELIVERY CHARGE MODAL
  // =====================================================

  const [chargeModal, setChargeModal] = useState({
    open: false,

    shop: null,

    restaurantId: undefined,
  });

  // =====================================================
  // SYNC ANLOOK
  // =====================================================

  const handleSyncAnlook = async () => {
    try {
      toast.success("Anlook sync completed successfully!");
    } catch (error) {
      toast.error("Error syncing with Anlook");
    }
  };

  // =====================================================
  // OPEN MODAL
  // =====================================================

  const openModal = (type, shop) => {
    setModalType(type);

    setSelectedShopId(shop?.id || null);

    // ===================================================
    // ASSIGN
    // ===================================================

    if (type === "assign") {
      const matchedTeam = (teams || []).find(
        (team) => String(team.team_name) === String(shop?.teamName),
      );

      setSelectedTeam(matchedTeam ? String(matchedTeam.id) : "");
    }

    // ===================================================
    // EDIT
    // ===================================================

    if (type === "edit") {
      setEditFormData({
        shopCode: shop?.shop_code || shop?.shopCode || shop?.user_code || "",

        shopLatitude:
          shop?.shop_latitude ?? shop?.shopLatitude ?? shop?.latitude ?? "",

        shopLongitude:
          shop?.shop_longitude ?? shop?.shopLongitude ?? shop?.longitude ?? "",
      });
    }
  };

  // =====================================================
  // CLOSE MODAL
  // =====================================================

  const closeModal = () => {
    setModalType("");

    setSelectedShopId(null);

    setSelectedTeam("");

    setEditFormData({
      shopCode: "",
      shopAddress: "",
      shopName: "",
      shopPhone: "",
      shopPinCode: "",
      shopPanCard: "",
      shopGst: "",
      shopLatitude: "",
      shopLongitude: "",
    });
  };

  // =====================================================
  // INITIAL SHOP LOAD
  // =====================================================

  useEffect(() => {
    fetchShops();
  }, []);

  // =====================================================
  // INITIAL TEAM LOAD
  // =====================================================

  useEffect(() => {
    fetchDriverTeams();
  }, []);

  // =====================================================
  // ADD DELIVERY CHARGE
  // =====================================================

  const openAddChargeModal = async (shop = null) => {
    setChargeModal({
      open: true,

      shop,

      restaurantId: undefined,
    });

    await fetchDeliveryCharges(shop?.shop_code || "");
  };

  // =====================================================
  // MANAGE DELIVERY CHARGE
  // =====================================================

  const openManageChargeModal = (group) => {
    setChargeModal({
      open: true,

      shop: null,

      restaurantId: group?.restaurant_id ?? null,
    });
  };

  // =====================================================
  // CLOSE DELIVERY MODAL
  // =====================================================

  const closeChargeModal = () => {
    setChargeModal({
      open: false,

      shop: null,

      restaurantId: undefined,
    });
  };

  // =====================================================
  // UI
  // =====================================================

  return (
    <div className="h-[calc(100vh-64px)] flex flex-col p-6 overflow-hidden">
      <Toaster position="top-right" />

      {/* =================================================
          TAB BAR
      ================================================= */}

      <div className="shrink-0 z-30">
        <div className="mb-4 border-b border-gray-200">
          <nav className="-mb-px flex space-x-8" aria-label="Tabs">
            {/* SHOP LIST */}

            <button
              type="button"
              onClick={() => setActiveTab("list")}
              className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${
                activeTab === "list"
                  ? "border-orange-600 text-orange-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              Shop List
            </button>

            {/* DELIVERY */}

            <button
              type="button"
              onClick={() => setActiveTab("deliveryCharges")}
              className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${
                activeTab === "deliveryCharges"
                  ? "border-orange-600 text-orange-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              Delivery Charges
            </button>

            {/* ONBOARDING */}

            <button
              type="button"
              onClick={() => setActiveTab("onboarding")}
              className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${
                activeTab === "onboarding"
                  ? "border-orange-600 text-orange-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              Onboarding
            </button>

            {/* ANLOOK */}

            <button
              type="button"
              onClick={() => setActiveTab("Anlook")}
              className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${
                activeTab === "Anlook"
                  ? "border-orange-600 text-orange-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              Sync Anlook
            </button>
          </nav>
        </div>
      </div>

      {/* =================================================
          TAB CONTENT
      ================================================= */}

      <div className="flex-1 min-h-0 overflow-y-auto">
        <ShopTabs
          activeTab={activeTab}
          loading={loading}
          shops={shops}
          fetchShops={fetchShops}
          updateShopStatus={updateShopStatus}
          statusUpdatingId={statusUpdatingId}
          openModal={openModal}
          openAddChargeModal={openAddChargeModal}
          AdminId={AdminId}
          formData={formData}
          setFormData={setFormData}
          fetchLatLong={fetchLatLong}
          addShop={addShop}
          setActiveTab={setActiveTab}
          deliveryCharges={deliveryCharges}
          deliveryChargesLoading={deliveryChargesLoading}
          fetchDeliveryCharges={fetchDeliveryCharges}
          openManageChargeModal={openManageChargeModal}
          handleSyncAnlook={handleSyncAnlook}
        />
      </div>

      {/* =================================================
          EDIT SHOP MODAL
      ================================================= */}

      {modalType === "edit" && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
          <div className="w-full max-w-md rounded-xl bg-white p-5 shadow-lg">
            <h2 className="mb-4 text-lg font-semibold text-gray-800">
              Update Shop Lat Long
            </h2>

            {/* SHOP CODE */}

            <div className="mb-3">
              <label className="mb-1 block text-sm font-medium text-gray-700">
                Shop Code
              </label>

              <input
                type="text"
                value={editFormData.shopCode}
                readOnly
                className="w-full cursor-not-allowed rounded-lg border border-gray-200 bg-gray-100 px-3 py-2 text-gray-700 outline-none"
                placeholder="Shop Code"
              />
            </div>

            {/* LATITUDE */}

            <div className="mb-3">
              <label className="mb-1 block text-sm font-medium text-gray-700">
                Latitude
              </label>

              <input
                type="number"
                step="any"
                inputMode="decimal"
                value={editFormData.shopLatitude}
                onChange={(e) =>
                  setEditFormData((prev) => ({
                    ...prev,

                    shopLatitude: e.target.value,
                  }))
                }
                className="w-full rounded-lg border border-gray-300 px-3 py-2 outline-none transition focus:border-orange-500 focus:ring-2 focus:ring-orange-200"
                placeholder="Enter Latitude"
              />
            </div>

            {/* LONGITUDE */}

            <div className="mb-4">
              <label className="mb-1 block text-sm font-medium text-gray-700">
                Longitude
              </label>

              <input
                type="number"
                step="any"
                inputMode="decimal"
                value={editFormData.shopLongitude}
                onChange={(e) =>
                  setEditFormData((prev) => ({
                    ...prev,

                    shopLongitude: e.target.value,
                  }))
                }
                className="w-full rounded-lg border border-gray-300 px-3 py-2 outline-none transition focus:border-orange-500 focus:ring-2 focus:ring-orange-200"
                placeholder="Enter Longitude"
              />
            </div>

            {/* ACTIONS */}

            <div className="flex justify-end gap-2">
              <button
                type="button"
                onClick={closeModal}
                className="rounded-lg bg-gray-200 px-4 py-2 text-sm text-gray-700 hover:bg-gray-300"
              >
                Cancel
              </button>

              <button
                type="button"
                disabled={
                  !String(editFormData.shopCode || "").trim() ||
                  !String(editFormData.shopLatitude ?? "").trim() ||
                  !String(editFormData.shopLongitude ?? "").trim()
                }
                onClick={async () => {
                  const shopCode = String(editFormData.shopCode || "").trim();

                  const latitude = String(
                    editFormData.shopLatitude ?? "",
                  ).trim();

                  const longitude = String(
                    editFormData.shopLongitude ?? "",
                  ).trim();

                  if (!shopCode || !latitude || !longitude) {
                    toast.error(
                      "Shop Code, Latitude and Longitude are required",
                    );

                    return;
                  }

                  const latitudeNumber = Number(latitude);

                  const longitudeNumber = Number(longitude);

                  if (
                    !Number.isFinite(latitudeNumber) ||
                    latitudeNumber < -90 ||
                    latitudeNumber > 90
                  ) {
                    toast.error("Latitude must be between -90 and 90");

                    return;
                  }

                  if (
                    !Number.isFinite(longitudeNumber) ||
                    longitudeNumber < -180 ||
                    longitudeNumber > 180
                  ) {
                    toast.error("Longitude must be between -180 and 180");

                    return;
                  }

                  await updateShopLatLong({
                    shopCode,

                    latitude,

                    longitude,

                    onSuccess: async () => {
                      closeModal();

                      await fetchShops();
                    },
                  });
                }}
                className="rounded-lg bg-orange-500 px-4 py-2 text-sm text-white transition hover:bg-orange-600 disabled:cursor-not-allowed disabled:bg-gray-300"
              >
                Update
              </button>
            </div>
          </div>
        </div>
      )}

      {/* =================================================
          ASSIGN TEAM MODAL
      ================================================= */}

      {modalType === "assign" && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="w-full max-w-md rounded-xl bg-white p-5 shadow-lg">
            <h2 className="mb-4 text-lg font-semibold text-gray-800">
              Assign Shop To Team
            </h2>

            <div className="mb-4">
              <label className="mb-1 block text-sm font-medium text-gray-700">
                Select Team
              </label>

              <TeamDropdown
                teams={(teams || []).map((team) => ({
                  id: team.id,

                  team_name: team.team_name,
                }))}
                value={selectedTeam}
                onChange={(id) => setSelectedTeam(String(id))}
                placeholder="Select Team"
                className="w-full"
                dropdownHeight="max-h-[220px]"
              />
            </div>

            <div className="flex justify-end gap-2">
              <button
                type="button"
                onClick={closeModal}
                className="rounded-lg bg-gray-200 px-4 py-2 text-sm"
              >
                Cancel
              </button>

              <button
                type="button"
                disabled={!selectedTeam}
                onClick={async () => {
                  const selectedShop = shops.find(
                    (shop) => String(shop.id) === String(selectedShopId),
                  );

                  await assignShopToTeam({
                    shopCode: selectedShop?.shop_code,

                    teamId: selectedTeam,

                    onSuccess: async () => {
                      closeModal();

                      await fetchShops();
                    },
                  });
                }}
                className="rounded-lg bg-blue-500 px-4 py-2 text-sm text-white disabled:bg-gray-300"
              >
                Assign
              </button>
            </div>
          </div>
        </div>
      )}

      {/* =================================================
          DELIVERY CHARGE MODAL
      ================================================= */}

      <DeliveryChargeModal
        open={chargeModal.open}
        shop={chargeModal.shop}
        restaurantId={chargeModal.restaurantId}
        shops={shops}
        deliveryCharges={deliveryCharges}
        saving={deliveryChargeSaving}
        deletingId={deliveryChargeDeletingId}
        onClose={closeChargeModal}
        onSave={async (payload, isUpdate) => {
          return await saveDeliveryCharge(payload, {
            isUpdate,
          });
        }}
        onDelete={async ({ userId, chargeId }) => {
          return await deleteDeliveryCharge({
            userId,
            chargeId,
          });
        }}
      />
    </div>
  );
}
